export default __webpack_public_path__ + "static/media/4.96aa1bf6.jpg";